import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError, phoneValid } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PhoneGate() {
  const { user, refresh, logout } = useAuth();
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!phoneValid(phone)) return toast.error("Informe um WhatsApp válido com DDD.");
    setSaving(true);
    try {
      await api.patch("/me", { phone });
      await refresh();
      toast.success("WhatsApp salvo!");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="phone-gate" className="flex min-h-screen items-center justify-center bg-[#0b1610] px-5">
      <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/5 p-6 text-white backdrop-blur">
        <MessageCircle className="h-10 w-10 text-emerald-300" />
        <h1 className="mt-4 font-display text-2xl font-black">Olá{user?.name ? `, ${user.name.split(" ")[0]}` : ""}!</h1>
        <p className="mt-1 text-sm text-emerald-100/70">Para continuar, informe seu WhatsApp com DDD. Usamos para falar com você sobre reservas e pedidos.</p>
        <Input data-testid="phone-gate-input" type="tel" inputMode="tel" placeholder="(48) 9 9999-9999" value={phone} onChange={(e) => setPhone(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} className="mt-4 rounded-xl border-white/20 bg-white/10 text-white placeholder:text-white/40" />
        <Button data-testid="phone-gate-save" onClick={save} disabled={saving} className="mt-3 w-full rounded-full bg-[#1B7A45] py-5 font-semibold hover:bg-[#156337]">{saving ? "Salvando..." : "Continuar"}</Button>
        <button data-testid="phone-gate-logout" onClick={logout} className="mt-3 w-full text-center text-xs text-white/50 hover:text-white/80">Sair</button>
      </div>
    </div>
  );
}
